import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let startDate = moment().startOf('year');
let endDate = moment().startOf('month');

import { SEARCH_PARAMS, PAGING_INFO } from './state';
//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			srchMm01: '', //판매월
			carScn: '', //차량구분
			pacScn: '', //승상구분
			srchMm02: '', //조건월
			partNo: '', //품번
			roNo: '', //RO No
			prtlSbc: '', //특이사항검색
			strtTotCst: '', //비용(from)
			endTotCst: '', //비용(to)
			saleNat: '', //판매국가
			saleRegn: '', //판매지역
			flclSpc: '', //연료전지사양
			cType: '', //클레임타입
			phmnCd: '', //현상코드
			opCd: '', //작업코드
			opCdNm: '', //작업코드
			prcStepGb: '', //처리단계
			prcRsltCd: '', //처리결과
			cmpnNo: '', //캠페인번호
			partType: '', //부품유형
			useTerm: '', //사용기간
			check: '', //누적
			carTypeNm: '', //차종유형
			m3IdxScn: '',

			strtMm01: startDate, //strtMm01
			endMm01: endDate, //endMm01
			strtMm02: startDate, //strtMm02
			endMm02: endDate //endMm01
		},

		grdList: [], //그리드리스트
		dayCols: [], //그리드 컬럼(년월컬럼)
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		pacScnList: [], //검색 승상구분 셀렉트박스
		saleRegnList: [], //검색 판매지역 셀렉트박스
		partTypeList: [], //검색 부품유형 셀렉트박스
		saleRegnList: [], //검색 판매지역 셀렉트박스
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		cTypeList: [], //검색 클레임타입 셀렉트박스
		phmnCdList: [], //검색 현상코드 셀렉트박스
		useTermList: [], //검색 사용기간 셀렉트박스
		carTypeNmList: [], //검색 차종유형 셀렉트박스
		prcsStepList: [], //조회조건 처리단계
		prcsRsltList: [], //조회조건 처리결과
		ceqTypeList: [], //정비유형
		idxScnList: [] //지수구분
	};
};

const selectDate1 = (state, { from, to }) => {
	state.searchParams.strtMm01 = from;
	state.searchParams.endMm01 = to;
};
const selectDate2 = (state, { from2, to2 }) => {
	state.searchParams.strtMm02 = from2;
	state.searchParams.endMm02 = to2;
};

export default {
	...common,
	selectDate1,
	selectDate2,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SEARCH_PARAM_INIT]: state => {
		//초기화
		state.searchParams = SEARCH_PARAMS();
	}
};
